module.exports = __webpack_public_path__ + "static/media/NAC---Desktop-UI---NAC-Experiences-(LL,-EP,-BS,-Alive)_Sample-9.jpg";